export default __webpack_public_path__ + "static/media/icon-print.73a8eed4.svg";